import { apiClient } from './api';
import { getEffectiveApiUrl } from '../config/runtimeEnv';

/**
 * Response from GET api/app/modules (enabled feature modules).
 */
export interface ModulesDto {
  automation: boolean;
  governance: boolean;
  integrations: boolean;
  globalAccessRoles: string[];
}

/** Raw response may use PascalCase (e.g. .NET) or camelCase. */
interface ModulesResponseRaw {
  automation?: boolean;
  governance?: boolean;
  integrations?: boolean;
  globalAccessRoles?: string[];
  Automation?: boolean;
  Governance?: boolean;
  Integrations?: boolean;
  GlobalAccessRoles?: string[];
}

function normalizeModules(raw: ModulesResponseRaw): ModulesDto {
  return {
    automation: raw.automation ?? raw.Automation ?? true,
    governance: raw.governance ?? raw.Governance ?? true,
    integrations: raw.integrations ?? raw.Integrations ?? true,
    globalAccessRoles: raw.globalAccessRoles ?? raw.GlobalAccessRoles ?? [],
  };
}

/**
 * Path to the modules endpoint that never duplicates /api.
 * baseURL may be "https://host/api" or "https://host" depending on env.
 */
function getModulesPath(): string {
  const base = getEffectiveApiUrl().replace(/\/+$/, '');
  return base.endsWith('/api') ? 'app/modules' : 'api/app/modules';
}

/**
 * Fetches which feature modules are enabled from the backend.
 */
export async function getModules(): Promise<ModulesDto> {
  const path = getModulesPath();
  const { data } = await apiClient.get<ModulesResponseRaw>(path);
  return normalizeModules(data);
}
